<template>

    <div class="dropdown d-inline-block effort-log" :ref="'dropdown-effort-parent-'+this.propItem.id">
        <button @click="show" :ref="'dropdown-effort-'+this.propItem.id" type="button" v-dropdown data-bs-auto-close="outside" class="btn collapsed"><i class="far fa-clock " v-bind:class="{'fa-spin': timerRunning == 2}"></i></button>

        <div class="dropdown-menu" style="min-height:460px;" v-on:click.stop>
            <h4>Effort Log</h4>

            <ul  class="nav nav-tabs">
                <li @click="tab = 'new'"><a class="nav-link" v-bind:class="{active: tab == 'new'}">Log Effort</a></li>
                <li @click="tab = 'timer'"><a class="nav-link" v-bind:class="{active: tab == 'timer'}">Timer</a></li>
                <li @click="tab = 'entries'"><a class="nav-link" v-bind:class="{active: tab == 'entries'}">Entries</a></li>
            </ul>

            <component v-if="display" :is="tab" :propItem="propItem" :propLogId="logId" @update-entry="onEditClick" :close="close"></component>

        </div>
    </div>

</template>

<script>
    import { Dropdown } from 'bootstrap-5'

    import InputMask from 'vue-input-mask'
    import Datepicker from 'vuejs-datepicker'
    import Multiselect from 'vue-multiselect'
    import New from './effort-log/new'
    import Entries from './effort-log/entries'
    import Timer from './effort-log/timer'

    import { filter, cloneDeep } from 'lodash'
    import Item from './../../../../models/item.js'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'

    let timeModel = function() {
        return {
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }

    export default {
        props: ['propItem', 'userStoryId'],
        components: {
            Multiselect,
            UserSelect,
            Item,
            Datepicker,
            InputMask,
            New,
            Entries,
            Timer
        },

        data: function () {
            return {
                item: new Item(),
                tab: 'new',
                log: {},
                logId: null,
                time: new timeModel(),
                interval: null,
                display: false
            }
        },

        computed: {
            ...mapGetters('yodizproject/stories', {
                getStoryById: 'getById'
            }),
            ...mapGetters('yodizproject/tasks', {
                getTaskById: 'getById'
            }),
            ...mapGetters('user', ['authorizedSelect']),
            ...mapState('yodizproject/effort', ['initialState']),
            ...mapState('user', ['timer']),
            ...mapGetters('yodizproject/effort', {
                getEfforyByItemId: 'getByItemId',
                getFocusedEffortLogItem: 'getById'
            }),



            timerRunning() {
                //Has timer running and is for this item
                if (this.timer && this.timer.item_id == this.propItem.id) {

                    //Current timer but paused
                    if (this.timer.started == null) {
                        return 3
                    }

                    return 2
                }

                //Has timer running for a different task
                if (this.timer) {
                    return 1
                }

                //No timer currently running
                return 0
            }


        },

        mounted: function() {

            //On Dropdown close (user click lost focus) clear any focused log entry
            this.$refs['dropdown-effort-parent-'+this.propItem.id].addEventListener('hide.bs.dropdown', () => {
                this.display = false
            })


            this.$refs['dropdown-effort-parent-'+this.propItem.id].addEventListener('show.bs.dropdown', () => {
                //Default to the timer tab if one is running
                if (this.timerRunning == 2) this.tab = 'timer'
            })

        },

        methods: {
            ...mapActions('yodizproject/effort', {
                addEffortLog: 'addListObject',
                updateEffortLog: 'updateListObject',
                deleteEffortLog: 'deleteListObject',
                resetEffortLog: 'resetSingle'
            }),
            ...mapActions('user', ['startTimer', 'pauseTimer', 'resumeTimer', 'logTimer', 'deleteTimer']),

            show() {
                this.resetEffortLog()
                this.display = true
            },

            close() {
                Dropdown.getOrCreateInstance(this.$refs['dropdown-effort-'+this.propItem.id]).hide()
            },

            onEditClick(id) {
                this.tab = 'new'
            },
        }
    }
</script>
